import * as baseDealSelectors from '@makemydeal/dr-dash-store/selectors/BaseDealSelectors';
import React from 'react';
import { useSelector } from 'react-redux';

type Callback = () => void;

export const useDealTabChange = (action: Callback) => {
    const activeTab = useSelector(baseDealSelectors.getActiveTab);
    React.useEffect(() => {
        action();
    }, [activeTab]);
};
